export class Location {
  name = ''
  address = ''
  phone = ''
  hours = ''
}
